<template>
    <div class="posterSet form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <div class="formBox">
                <div class="titleBox">
                    <p class="title">海报设置</p>
                </div>
                <div class="contentBox">
                    <div class="left">
                        <el-form-item label="海报图片" class="posterImg" prop="postercoveratturlid">
                            <div class="imgBox">
                                <i class="el-icon-picture" v-if="!ruleForm.coveratturlidobj"></i>
                                <img class="activityCoverImage" :src="ruleForm.coveratturlidobj.furl + '?' + time" v-else-if="ruleForm.coveratturlidobj && ruleForm.coveratturlidobj.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox">
                                <UploadFile :uploadType="uploadVideoType" @setFile="setPosterFile" :fileRule="fileRule"></UploadFile>
                                <!-- <el-button @click.native="openPosterDialog">选择文件</el-button> -->
                                <p>建议尺寸750*1334px的JPG、PNG格式， 图片小于2M。</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="邀请头像" prop="name">
                            <el-switch v-model="ruleForm.isdisplayheadimg"></el-switch>
                            <el-radio-group v-model="ruleForm.headimgstyle" :disabled='!ruleForm.isdisplayheadimg'>
                                <el-radio :label="1">圆形</el-radio>
                                <el-radio :label="2">方形</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="邀请昵称" prop="name" class="inviteImg">
                            <el-switch v-model="ruleForm.isdisplaynickname"></el-switch>
                            <el-color-picker v-model="ruleForm.nicknamecolor" :disabled="!ruleForm.isdisplaynickname"></el-color-picker>
                            <el-slider :min='6' :max="48" v-model="ruleForm.nicknamesize" :disabled="!ruleForm.isdisplaynickname"></el-slider>
                        </el-form-item>
                        <el-form-item label="二维码" prop="name">
                            <el-switch v-model="ruleForm.isdisplayqrcode"></el-switch>
                        </el-form-item>
                    </div>
                    <div class="right">
                        <img :src="ruleForm.postercoveratturlidImg.furl + '?' + time" class="posterBg" v-if="(ruleForm.postercoveratturlidImg && ruleForm.postercoveratturlidImg.furl + '?' + time)" alt="">
                        <div @mousedown="moveHeadImg" :style="{top: ruleForm.headimgposition.split(',')[1] + 'px', left: ruleForm.headimgposition.split(',')[0] + 'px'}" :class="{'headImg': true, 'side': ruleForm.headimgstyle === 2, 'circle': ruleForm.headimgstyle === 1}" v-if="ruleForm.isdisplayheadimg">
                            头像
                        </div>
                        <div @mousedown="moveNickname" :style="{color: ruleForm.nicknamecolor ? ruleForm.nicknamecolor : '#303133', fontSize: ruleForm.nicknamesize + 'px', top: ruleForm.nicknameposition.split(',')[1]+'px', left: ruleForm.nicknameposition.split(',')[0]+'px'}" class="nickname" v-if="ruleForm.isdisplaynickname">用户昵称</div>
                        <!-- <img @mousedown="moveCode" class="serviceCode" v-if="ruleForm.isdisplayqrcode" :style="{top: ruleForm.qrcodeposition.split(',')[1]+'px', left: ruleForm.qrcodeposition.split(',')[0]+'px'}" :src="require('@/common/images/toolmgt/code.png')" alt=""> -->

                        <div @mousedown="moveCode" v-show="ruleForm.isdisplayqrcode" class="rightCodeBox" :style="{top: ruleForm.qrcodeposition.split(',')[1]+'px', left: ruleForm.qrcodeposition.split(',')[0]+'px'}">
                            <div class="cover"></div>
                            <img class="serviceCode" :src="require('@/common/images/toolmgt/code.png')" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="btnBox">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
            </div>
        </el-form>
        <ShopLocalCropper :cropperOption="posterCropperOption" ref="posterLocalCropper" @setImage="_setPosterImage" :uploadType="uploadType"></ShopLocalCropper>
    </div>
</template>
<script>
import UploadFile from 'base/upload/uploadFile2'
import {getPoster, addUpdatePoster} from 'api/nationalDistribution'
import {mapGetters, mapActions} from 'vuex'
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import {computeFileSize} from 'common/js/tools'
export default {
    name: 'posterSet',
    data() {
        let checkcoveratturlid = (rule,value, callback) => {
            if (this.ruleForm.coveratturlid) {
                callback()
            } else {
                callback('请上传海报图片')
            }
        }
        return {
            time: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            ruleForm: {
                coveratturlidobj: '',
                postercoveratturlidImg: '',
                isdisplayheadimg: true,
                headimgstyle: 1,
                headimgposition: '22,22', // 头像位置——格式X,Y
                isdisplaynickname: true,
                nicknamecolor: '#000000',
                nicknamesize: 10,
                nicknameposition: '72,32', // 昵称位置——格式X,Y
                isdisplayqrcode: true,
                qrcodeposition: '190,420', // 二维码位置——格式X,Y
            },
            rules: {
                coveratturlid : [
                    {validator: checkcoveratturlid, trigger: 'blur'}
                ]
            },
            uploadVideoType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            posterCropperOption: {
                fixedNumber: [750, 1334], // 截图框的宽高比例
                enlarge: 7.5, // 图片根据截图框输出比例倍数
                autoCropWidth: 100, // 默认生成截图框宽度
                autoCropHeight: 177 // 默认生成截图框高度
            },
            fileRule: {
                btnName: '选择文件',
                cls: '',
                accept: '.jpg,.jpeg,.png',
                size: 2,
                width: '750',
                height: '420'
            },
        }
    },
    created() {
        if (this.$route.query.eventinnerid && this.$route.query.posterinnerid) {
            this.getPoster()
        }
    },
    methods: {
        _setPosterImage(file) {
            this.time = new Date().getTime()
            this.$nextTick(() => {
                this.ruleForm.coveratturlidobj = file
            })
        },
        openPosterDialog() {
            this.$refs.posterLocalCropper.openDialog()
        },
        getPoster() {
            this.setLoading(true)
            getPoster({
                data: {eventinnerid: this.$route.query.eventinnerid, innerid: this.$route.query.posterinnerid},
                success: data => {
                    this.setLoading(false)
                    if (data.data.isdisplayheadimg) {
                        data.data.isdisplayheadimg = true
                    } else {
                        data.data.isdisplayheadimg = false
                    }
                    if (data.data.isdisplaynickname) {
                        data.data.isdisplaynickname = true
                    } else {
                        data.data.isdisplaynickname = false
                    }
                    if (data.data.isdisplayqrcode) {
                        data.data.isdisplayqrcode = true
                    } else {
                        data.data.isdisplayqrcode = false
                    }
                    data.data.nicknamesize = Number(data.data.nicknamesize)
                    data.data.postercoveratturlidImg = data.data.coveratturlidobj
                    this.ruleForm = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate(v => {
                if (v) {
                    delete this.ruleForm.coveratturlidobj.type
                    this.ruleForm.coveratturlidobj = JSON.stringify(this.ruleForm.coveratturlidobj)
                    if (this.ruleForm.isdisplayheadimg) {
                        this.ruleForm.isdisplayheadimg = 1
                    } else {
                        this.ruleForm.isdisplayheadimg = 0
                    }
                    if (this.ruleForm.isdisplaynickname) {
                        this.ruleForm.isdisplaynickname = 1
                    } else {
                        this.ruleForm.isdisplaynickname = 0
                    }
                    if (this.ruleForm.isdisplayqrcode) {
                        this.ruleForm.isdisplayqrcode = 1
                    } else {
                        this.ruleForm.isdisplayqrcode = 0
                    }
                    this.setLoading(true)
                    addUpdatePoster({
                        data: Object.assign({}, this.ruleForm, {eventinnerid: this.$route.query.eventinnerid}),
                        success: data => {
                            this.setLoading(false)
                            this.$router.push({name: 'NDPosterList', query: {innerid: this.$route.query.eventinnerid}})
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                } else {
                    return false
                }
            })
        },
        cancel() {

        },
        setPosterFile(file) {
            computeFileSize()
            this.ruleForm.coveratturlidobj = file
            this.ruleForm.postercoveratturlidImg = file
            this.time = new Date().getTime()
        },
        // 移动头像
        moveHeadImg(e) {
            let odiv = e.target       //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft
            let disY = e.clientY - odiv.offsetTop
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX
                let top = e.clientY - disY
                //移动当前元素
                if (left >= 0 && left < 250) {
                    odiv.style.left = left + 'px'
                    this.ruleForm.headimgposition = left + ',' + this.ruleForm.headimgposition.split(',')[1]
                }
                if (top >= 0 && top < 484) {
                    odiv.style.top = top + 'px'
                    this.ruleForm.headimgposition = this.ruleForm.headimgposition.split(',')[0] + ',' + top
                }
            }
            document.onmouseup = (e) => {
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        // 移动昵称
        moveNickname(e) {
            let odiv = e.target       //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft
            let disY = e.clientY - odiv.offsetTop
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX
                let top = e.clientY - disY
                //移动当前元素
                if (left >= 0 && left < 250) {
                    odiv.style.left = left + 'px'
                    this.ruleForm.nicknameposition = left + ',' + this.ruleForm.nicknameposition.split(',')[1]
                }
                if (top >= 0 && top < 482) {
                    odiv.style.top = top + 'px'
                    this.ruleForm.nicknameposition = this.ruleForm.nicknameposition.split(',')[0] + ',' + top
                }
            }
            document.onmouseup = (e) => {
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        // 移动二维码
        moveCode(e) {
            let odiv = e.target.parentElement       //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft
            let disY = e.clientY - odiv.offsetTop
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX
                let top = e.clientY - disY
                //移动当前元素
                if (left >= 0 && left < 235) {
                    odiv.style.left = left + 'px'
                    this.ruleForm.qrcodeposition = left + ',' + this.ruleForm.qrcodeposition.split(',')[1]
                }
                if (top >= 0 && top < 470) {
                    odiv.style.top = top + 'px'
                    this.ruleForm.qrcodeposition = this.ruleForm.qrcodeposition.split(',')[0] + ',' + top
                }
            }
            document.onmouseup = (e) => {
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    components: {
        UploadFile, ShopLocalCropper
    }
}
</script>
<style lang="scss">
@import "~common/scss/mixin";
@import "~common/scss/base";
.form {
    margin-top: 0px;
}
    .posterSet{
        .posterImg{
            .el-form-item__label::after{
                content: '*';
                color: #FF7575;
                margin-left: 4px;
            }
        }
        .formBox{
            background: #fff;
            padding: 20px 0;
            .titleBox{
                padding: 0 20px 20px;
                border-bottom: 1px solid #DCDFE6;
                // .titleBox{
                //     padding: 0 20px;

                // }
                .title{
                    padding-left: 8px;
                    font-size: 16px;
                    font-weight: 500;
                    border-left: 2px solid #409EFF;
                }
            }
            .contentBox{
                display: flex;
                padding-top: 20px;
                .left{
                    .el-form-item{
                        .el-switch{
                            margin-right: 30px;
                        }
                    }
                    .posterImg{
                        .el-form-item__content{
                            display: flex;
                            align-items: center;
                            .imgBox{
                                width: 178px;
                                height: 318px;
                                background: #F5F7FA;
                                text-align: center;
                                line-height: 318px;
                                .el-icon-picture{
                                    color: #DCDFE6;
                                    font-size: 40px;
                                }
                                .activityCoverImage{
                                    width: 178px;
                                    height: 318px;
                                }
                            }
                            .uploadFileBox{
                                margin-left: 12px;
                                .uploadFile{
                                    .upload-demo{
                                        .el-upload {
                                            .el-button{
                                                background: #fff;
                                                color: #000;
                                                border: 1px solid #C0C4CC;
                                            }
                                        }
                                    }
                                }
                                p{
                                    color: #909399;
                                    font-size: 14px;
                                    line-height: 20px;
                                }
                            }
                        }
                    }
                    .inviteImg{
                        .el-form-item__content{
                            display: flex;
                            align-items: center;
                            .el-color-picker {
                                width: 16px;
                                height: 16px;
                                margin-right: 28px;
                                .el-color-picker__trigger{
                                    padding: 0;
                                    width: 16px;
                                    height: 16px;
                                }
                            }
                            .el-slider{
                                width: 160px;
                                display: inline-block;
                            }
                        }
                    }
                    .serviceSet{
                        .title{
                            border-bottom: none;
                        }
                    }
                    .el-radio__input.is-checked+.el-radio__label{
                        color: #303133;
                    }
                }
                .right{
                    width: 300px;
                    height: 534px;
                    background:rgba(242,246,252,1);
                    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.3);
                    overflow: hidden;
                    margin-left: 100px;
                    margin-left: 270px;
                    position: relative;
                    .posterBg{
                        width: 300px;
                        height: 534px;
                    }
                    .headImg{
                        width: 32px;
                        height: 32px;
                        background: #D8D8D8;
                        border: 1px solid #979797;
                        text-align: center;
                        line-height: 32px;
                        position: absolute;
                    }
                    .side{
                        border-radius: 0;
                        cursor: move;
                    }
                    .circle{
                        border-radius: 50%;
                        cursor: move;
                    }
                    .nickname{
                        position: absolute;
                        cursor: move;
                    }
                    .rightCodeBox{
                        cursor: move;
                        position: absolute;
                        .cover{
                            width: 64px;
                            height: 64px;
                            position: absolute;
                        }
                        img{
                            width: 64px;
                            height: 64px;
                        }
                    }
                }
            }
        }
        .btnBox{
            height: 80px;
            line-height: 80px;
            background: #fff;
            margin-top: 20px;
            text-align: center;
        }
    }
</style>
